import { SubtleButton } from '@/components/buttons/SubtleButton';
import UnderlineHeading from '@/components/heading/UnderlineHeading';
import { Link } from 'react-router-dom';

const OrderDetailsPage = () => {
    return (
        <div className="w-full mt-6 z-10">
            <div className="flex flex-row justify-between mb-6">
                <UnderlineHeading text="orders" />
                <Link to="/orders">
                    <SubtleButton>عودة للقائمة الرئيسية</SubtleButton>
                </Link>
            </div>
        </div>
    );
};

export default OrderDetailsPage;
